module.exports = __webpack_public_path__ + "static/fail.f764a164.png";